module.exports = __webpack_public_path__ + "images/bg-logout-cbe168d2.svg";